/**
 * custom.js
 * Listens for variant changes published via FoxTheme.pubsub
 * and dispatches a native CustomEvent for broader compatibility.
 */


FoxTheme.DOMready(function () {

  // Handle unavailable variant selection via raw DOM (FoxTheme doesn't fire variantChange for unavailable variants)
  document.addEventListener('change', (event) => {
  if (!event.target || !event.target.name || !event.target.name.includes('Bundle')) return;

  setTimeout(() => {
    const sizeFieldset = [...document.querySelectorAll('fieldset')]
      .find(fieldset =>
        fieldset.querySelector('legend')?.textContent.includes('Size')
      );

    if (!sizeFieldset) return;

    const selectedSize = sizeFieldset.querySelector(
      'input[type="radio"]:checked'
    );

    if (selectedSize?.classList.contains('disabled')) {
      const nextAvailable = sizeFieldset.querySelector(
        'input[type="radio"]:not(.disabled)'
      );

      nextAvailable?.click();
    }
  }, 500);
});

  // Update ingredient and description accordion content on variant change

  FoxTheme.pubsub.subscribe(
    FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
    function (data) {
      const variant = data.data.variant;
      if (!variant) return;

      // Deselect all ingredient and description contents
      document.querySelectorAll('.ingredient-content, .description-content').forEach(function (el) {
        el.classList.remove('selected');
      });

      // Select the matching variant's ingredient
      const selectedIngredient = document.querySelector(`[data-ingredient="${variant.title}"]`);
      if (selectedIngredient) {
        selectedIngredient.classList.add('selected');
      }

      // Select the matching variant's description
      const selectedDescription = document.querySelector(`.description-content[data-ingredient="${variant.title}"]`);
      if (selectedDescription) {
        selectedDescription.classList.add('selected');
      }
    }
  );


  // Javascript obfuscation for email inputs.
  // Removing the href hides the address from scrapers, but it also drops the link
  // role and keyboard focus, so both are restored explicitly below.
    document.querySelectorAll('a[href^="mailto:"]').forEach(function (el) {
      var email = el.getAttribute('href').replace('mailto:', '');
      var encoded = btoa(email);

      // Remove the real href from the DOM
      el.removeAttribute('href');
      el.setAttribute('data-e', encoded);
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.style.cursor = 'pointer';

      var openMail = function () {
        window.location.href = 'mailto:' + atob(el.getAttribute('data-e'));
      };

      // Rebuild and trigger only on user interaction
      el.addEventListener('click', openMail);
      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          openMail();
        }
      });
    });

});